export default __webpack_public_path__ + "60724f9f546295f8ebdbdcf9ae6407c4.png";